import React from "react";

type PropsType = {
  color?: string;
  style?: React.CSSProperties;
  size?: number;
};

const CustomPricing = ({ size = 61, style = {} }: PropsType) => {
  return (
    <svg
      width={size}
      height={(size / 61) * 60}
      style={style}
      viewBox="0 0 61 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_107_43034)">
        <path
          d="M9.5 23C9.5 21.8954 10.3954 21 11.5 21H17.5C18.6046 21 19.5 21.8954 19.5 23V52H9.5V23Z"
          stroke="#003125"
          stroke-width="4"
        />
        <path
          d="M19.5 11.212C19.5 8.30286 22.5068 6.36673 25.1552 7.57055L39.1552 13.9342C40.5832 14.5833 41.5 16.0071 41.5 17.5757V52H19.5V11.212Z"
          stroke="#003125"
          stroke-width="4"
        />
        <path
          d="M41.5 26.5841C41.5 25.0184 43.2177 24.0599 44.5502 24.882L49.6004 27.9981C50.7811 28.7266 51.5 30.0149 51.5 31.4023V52H41.5V26.5841Z"
          stroke="#003125"
          stroke-width="4"
        />
        <path
          d="M2.5 52H58.5"
          stroke="#003125"
          stroke-width="4"
          stroke-linecap="round"
        />
        <rect
          x="26.5"
          y="41"
          width="8"
          height="10"
          rx="1"
          stroke="#003125"
          stroke-width="4"
        />
        <rect x="25.5" y="19" width="4" height="4" rx="1" fill="#003125" />
        <rect x="25.5" y="25" width="4" height="4" rx="1" fill="#003125" />
        <rect x="25.5" y="31" width="4" height="4" rx="1" fill="#003125" />
        <rect x="31.5" y="19" width="4" height="4" rx="1" fill="#003125" />
        <rect x="31.5" y="25" width="4" height="4" rx="1" fill="#003125" />
        <rect x="31.5" y="31" width="4" height="4" rx="1" fill="#003125" />
      </g>
      <defs>
        <clipPath id="clip0_107_43034">
          <rect
            width="60"
            height="60"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CustomPricing;
